import { List, Record } from 'immutable';
import { CONTACTS_LISTS_ACCESS, CONTACTS_LISTS_READ, CONTENT_CORE_API_ACCESS, CONTENT_EDITOR_ACCESS, CUSTOMER_PORTAL_CONFIG_READ, KNOWLEDGE_CATEGORY_EDIT, MARKETING_VIDEO, SERVICE_CONTENT_RESTRICTED_WRITE, KNOWLEDGE_BASE_PRIVATE_CONTENT_PUBLISH, SERVICE_KNOWLEDGE_ACCESS_SCOPE, SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE, SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE, SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE } from '../constants/ScopesConstants';
const SCOPES_OBJECT = {
  [CONTACTS_LISTS_ACCESS]: false,
  [CONTACTS_LISTS_READ]: false,
  [CONTENT_CORE_API_ACCESS]: false,
  [CONTENT_EDITOR_ACCESS]: false,
  [CUSTOMER_PORTAL_CONFIG_READ]: false,
  [MARKETING_VIDEO]: false,
  [SERVICE_CONTENT_RESTRICTED_WRITE]: false,
  [KNOWLEDGE_BASE_PRIVATE_CONTENT_PUBLISH]: false,
  [SERVICE_KNOWLEDGE_ACCESS_SCOPE]: false,
  [SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE]: false,
  [SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE]: false,
  [SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE]: false,
  [KNOWLEDGE_CATEGORY_EDIT]: false
};
class KnowledgeScopes extends Record({
  canAccessLists: false,
  canEditAdminSettings: false,
  canPublishArticle: false,
  canRestrictContent: false,
  canPublishPrivateContent: false,
  canWriteArticle: false,
  hasContentEditorAccess: false,
  hasCustomerPortal: false,
  hasMarketingVideo: false,
  hasServiceAccess: false,
  hasSiteSettingsAccess: false,
  canEditCategories: false,
  scopes: List()
}) {
  static from(scopes) {
    let numFoundScopes = 0;
    let i = 0;
    const maxFoundScopes = Object.keys(SCOPES_OBJECT).length;
    while (i < scopes.length) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (SCOPES_OBJECT[scopes[i]] !== undefined) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        SCOPES_OBJECT[scopes[i]] = true;
        numFoundScopes++;
      }
      if (numFoundScopes === maxFoundScopes) break;
      i++;
    }
    return new KnowledgeScopes({
      canAccessLists: SCOPES_OBJECT[CONTACTS_LISTS_ACCESS] || SCOPES_OBJECT[CONTACTS_LISTS_READ],
      canPublishArticle: SCOPES_OBJECT[SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE],
      canEditAdminSettings: SCOPES_OBJECT[SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE],
      canRestrictContent: SCOPES_OBJECT[SERVICE_CONTENT_RESTRICTED_WRITE],
      canPublishPrivateContent: SCOPES_OBJECT[KNOWLEDGE_BASE_PRIVATE_CONTENT_PUBLISH],
      canWriteArticle: SCOPES_OBJECT[SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE],
      hasContentEditorAccess: SCOPES_OBJECT[CONTENT_EDITOR_ACCESS],
      hasCustomerPortal: SCOPES_OBJECT[CUSTOMER_PORTAL_CONFIG_READ],
      hasMarketingVideo: SCOPES_OBJECT[MARKETING_VIDEO],
      hasServiceAccess: SCOPES_OBJECT[SERVICE_KNOWLEDGE_ACCESS_SCOPE],
      hasSiteSettingsAccess: SCOPES_OBJECT[CONTENT_CORE_API_ACCESS],
      canEditCategories: SCOPES_OBJECT[KNOWLEDGE_CATEGORY_EDIT],
      scopes
    });
  }
}
export default KnowledgeScopes;